import ProductPanel from './productPanel.container';

export default ProductPanel;